import script from "./WarrantySalesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WarrantySalesModal.vue?vue&type=script&setup=true&lang=js"

import "./WarrantySalesModal.vue?vue&type=style&index=0&id=388d1aa7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-388d1aa7"]])

export default __exports__